// Cookie utility functions for authentication

// Set a cookie with proper attributes
export const setCookie = (name, value, options = {}) => {
  const {
    expires = 1, // Default 1 day
    path = "/",
    secure = process.env.NODE_ENV === "production",
    sameSite = "Lax",
  } = options;

  const cookieValue = encodeURIComponent(value);
  const expiresDate = new Date();
  // expires is in days, convert to milliseconds
  expiresDate.setTime(expiresDate.getTime() + expires * 24 * 60 * 60 * 1000);

  const cookieString = `${name}=${cookieValue}; expires=${expiresDate.toUTCString()}; path=${path}; SameSite=${sameSite}${
    secure ? "; Secure" : ""
  }`;

  document.cookie = cookieString;
};

// Get a cookie value
export const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      const value = decodeURIComponent(c.substring(nameEQ.length, c.length));
      return value;
    }
  }
  return null;
};

// Delete a cookie
// Tries multiple paths since cookies might be set with different paths
export const deleteCookie = (name, path = "/") => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
};

// export const setHourlyCookie = (name, value, options = {}) => {
//   const expiresDate = new Date();
//   expiresDate.setTime(expiresDate.getTime() + (72 * 60 * 60 * 1000)); // 3 days

//   const cookieValue = encodeURIComponent(value);
//   const cookieString = `${name}=${cookieValue}; expires=${expiresDate.toUTCString()}; path=${options.path || "/"}; SameSite=${options.sameSite || "Lax"}${options.secure ? "; Secure" : ""}`;

//   document.cookie = cookieString;
// };

// Check if cookies are enabled
export const areCookiesEnabled = () => {
  try {
    setCookie("test", "test");
    const result = getCookie("test") === "test";
    deleteCookie("test");
    return result;
  } catch (e) {
    return false;
  }
};
